import { render, staticRenderFns } from "./TransferTab65.vue?vue&type=template&id=635fb856&scoped=true"
import script from "./TransferTab65.vue?vue&type=script&lang=js"
export * from "./TransferTab65.vue?vue&type=script&lang=js"
import style0 from "./TransferTab65.vue?vue&type=style&index=0&id=635fb856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635fb856",
  null
  
)

export default component.exports